var _implements = require('util/interface')._implements;

var TypedSubscriptionProxy = require('features/topics/typed-subscription-proxy');
var TypedSubscription = require('../../../events/typed-subscription');

module.exports = _implements(TypedSubscription, function TypedSubscriptionImpl(registry, stream, selector) {
    for (var fn in stream) {
        this[fn] = stream[fn];
    }

    this.selector = selector;
});


//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/features/topics/typed-subscription.js
// module id = 1001
// module chunks = 1